module.exports = __webpack_public_path__ + "img/zz9.b5faf06a.png";